export interface CIOMODBUSSTAT {
  STATS_ENUM: number;
  STATS_FAIL: number;
  STATS_SUCCESS: number;
}

export interface Connection {
  name: string;
  network: string;
  status: string | undefined;
  cIO_MODBUS_STATS: CIOMODBUSSTAT[];
}

export class cIO_MODBUS_TREE {
  alarm: boolean = true;
  brandcode: number = 0;
  current: number = 0;
  description: string = "Not used";
  device: string = "undefined";
  nodeerror: number = 0;
  nodeerrorstr: string = "";
  nodeid: number = -1;
  target: number = -1;
  value: number = -1;

  sensor1_type: number = -1;
  sensor1_value: number = -1;
  sensor2_type: number = -1;
  sensor2_value: number = -1;

  constructor() {
  }

}

export interface CIOMODBUSWORLD {
  Connection: Connection;
  cIO_MODBUS_TREE: cIO_MODBUS_TREE[];
}

export interface  cIO_MODBUS_ROOT {
  cIO_MODBUS_WORLD: CIOMODBUSWORLD[];
}




